
  import {defineComponent} from 'vue'

  export default defineComponent({
    name: 'GuoCangFooter',
    props: {
      msg: String
    }
  })
